import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Layout = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  paddingBottom: theme.baseUnit * 2,
  paddingTop: theme.baseUnit * 2,
  '@media (max-width: 800px)': {
    flexDirection: 'column',
  },
}));

export const Content = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.colors.gray['1'],
  boxShadow: '0px 4px 8px 0px rgba(105, 117, 127, 0.48)',
  borderRadius: theme.baseUnit,
  padding: theme.baseUnit * 10,
  maxWidth: theme.baseUnit * 70,
  boxSizing: 'border-box',
}));

export const HeaderMessageContainer = styled(Box)(({ theme }) => ({
  padding: theme.baseUnit * 2,
  backgroundColor: theme.colors.aquamarine[50],
  borderRadius: theme.baseUnit,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.colors.aquamarine[400],
  marginBottom: theme.baseUnit * 4,
  display: 'flex',
  flexDirection: 'row',
}));

export const Footer = styled('div')(({ theme }) => ({
  zIndex: 10,
  fontSize: '14px',
  border: 'none',
  marginTop: theme.baseUnit * 6,
  paddingTop: theme.baseUnit * 3,
  outline: 'none',
  borderTop: `2px solid ${theme.colors.alias.mainBackgroundDivider}`,
}));
interface SignUpTextProps {
  large?: boolean;
}

export const SignUp = styled('div')<SignUpTextProps>(({ theme, large }) => ({
  padding: large ? `0px ${theme.baseUnit * 4}px` : theme.baseUnit * 4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '320px',
}));

export const SignUpText = styled('div')<SignUpTextProps>(({ large }) => ({
  maxWidth: large ? '340px' : '200px',
  textAlign: 'center',
}));

// T Y P O G R A P H Y
export const Title = styled('h1')(({ theme }) => ({
  ...theme.typography.textVariant.title.l,
  color: theme.colors.alias.textPrimary,
  marginTop: 0,
  marginBottom: theme.baseUnit * 3,
}));

export const Subtitle = styled('p')(({ theme }) => ({
  ...theme.typography.textVariant.subtitle.m,
  color: theme.colors.alias.textSecondary,
  marginTop: 0,
  marginBottom: theme.baseUnit * 4,
}));

export const SignUpTitle = styled('h1')<SignUpTextProps>(
  ({ theme, large }) => ({
    ...theme.typography.textVariant.title.s,
    fontSize: large
      ? theme.typography.textVariant.title.l.fontSize
      : theme.typography.textVariant.body.m.fontSize,
    color: theme.colors.alias.textPrimary,
    marginTop: theme.baseUnit,
    marginBottom: large ? theme.baseUnit * 3 : theme.baseUnit,
  }),
);

export const SignUpSubtitle = styled('p')<SignUpTextProps>(({ theme }) => ({
  ...theme.typography.textVariant.body.m,
  color: theme.colors.alias.textSecondary,
  marginTop: 0,
  marginBottom: theme.baseUnit * 6,
}));

export const Note = styled('p')(({ theme }) => ({
  ...theme.typography.textVariant.subtitle.s,
  color: theme.colors.alias.textSecondary,
  marginTop: theme.baseUnit * 3,
}));

export const HintList = styled('ul')(({ theme }) => ({
  marginBottom: theme.baseUnit * 2,
  listStyle: 'none',
  paddingLeft: 0,
}));

export const HintItem = styled('li')(({ theme }) => ({
  ...theme.typography.textVariant.body.s,
  color: theme.colors.alias.textSecondary,
  lineHeight: 1.5,
}));

export const TextLink = styled('a')(({ theme }) => ({
  ...theme.typography.textVariant.subtitle.s,
  ...theme.typography.fontFamily.reader500,
  fontSize: theme.typography.textVariant.button.l.fontSize,
  color: theme.colors.alias.textSecondary,
  display: 'block',
  margin: 0,
  marginTop: theme.baseUnit * 3,
  textDecorationLine: 'underline',
  cursor: 'pointer',
}));

export const TextButton = styled('button')(({ theme }) => ({
  ...theme.typography.textVariant.subtitle.s,
  ...theme.typography.fontFamily.reader500,
  color: theme.colors.alias.textSecondary,
  background: 'none',
  border: 'none',
  display: 'block',
  margin: 0,
  padding: 0,
  marginTop: theme.baseUnit * 3,
  textDecorationLine: 'underline',
  cursor: 'pointer',
  textAlign: 'left',
}));

export const ErrorContainer = styled('p')(({ theme }) => ({
  ...theme.typography.textVariant.subtitle.s,
  color: theme.colors.alias.textContrast,
  margin: 0,
  textAlign: 'center',
  padding: theme.baseUnit * 2,
  backgroundColor: theme.colors.alias.statusError,
}));

export const ErrorText = styled('p')(({ theme }) => ({
  ...theme.typography.textVariant.body.s,
  color: theme.colors.error,
  margin: 0,
  marginTop: theme.baseUnit,
}));
